import {
  recognitionValuesService,
  CreateRecognitionValueRequest,
  RecognitionValue,
  UpdateRecognitionValueRequest,
} from '@aslanpay/portal-common-lib';
import { useMutation } from '@tanstack/react-query';

interface UpdateValueVariables {
  valueId: string;
  body: UpdateRecognitionValueRequest;
}

const useRecognitionValueMutations = () => {
  const createValue = useMutation<RecognitionValue, Error, CreateRecognitionValueRequest>((body) =>
    recognitionValuesService.createRecognitionValue(body)
  );

  const updateValue = useMutation<RecognitionValue, Error, UpdateValueVariables>(
    ({ valueId, body }) => recognitionValuesService.updateRecognitionValue(valueId, body)
  );

  const deleteValue = useMutation<unknown, Error, string>((valueId) =>
    recognitionValuesService.deleteRecognitionValue(valueId)
  );

  return { createValue, updateValue, deleteValue };
};

export default useRecognitionValueMutations;
